module.exports = __webpack_public_path__ + "img/image01.20b39e10.jpg";